import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from "reactstrap";
import { setLoading } from '../../store/slices/auth';
import { CustomButton, showToaster, toasterTypes } from '../../widgets';
import { FieldItem } from "../../widgets/fields";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import ModalComponent from '../common/Modal/modal';
import { addEducation, getColleges, getCountries, getCourse, getFieldStudy, getStates, updateEducation } from './apiController';
import { EducationFormElements } from './FormElements';
//import { id } from 'react-horizontal-scrolling-menu/dist/types/constants';
import dayjs from 'dayjs';

export default function EducationDetails(props) {
	const initialValues = React.useMemo(() => ({ institute: '', description: '', degree: null, fieldOfStudy: null, currentEducation: null, startingFrom: null, to: null, activities: [], country: null, state: null, city: '' }), []);
	const [values, fields, handleChange, { validateValues, reset, updateValue }] = useFieldItem(EducationFormElements, initialValues, { onValueChange });
	const [degreeList, setdegreeList] = useState([{ label: 'Post Graduation', value: 'postGraduation' }, { label: 'Graduation', value: 'graduation' }]);
	const [fieldOfStudyList, setfieldOfStudyList] = useState([{ label: 'Experience Design', value: 'experienceDesign' }]);
	const [activityList, setactivityList] = useState<any>([])
	const [countryList, setcountryList] = useState([]);
	const [courseList, setcourseList] = useState([]);
	const [fieldStudyList, setfieldstudyList] = useState([]);
	const [collegelist, setcollegeList] = useState<any>([]);
	const [stateList, setstateList] = useState([]);
	const { selectedIndex, data } = props;
	const dispatch = useDispatch();

	useEffect(() => {
		if (selectedIndex !== null && selectedIndex >= 0 && data && data.length > 0) {
			let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			let monthDate: any = "";
			if (data[selectedIndex].end_month != "till_date") {
				var monthIndex = months.indexOf(data[selectedIndex].end_month.split(' ')[1]) + 1
				var monthIndexval = monthIndex < 10 ? "0" + monthIndex : monthIndex
				monthDate = parseInt(data[selectedIndex].end_month.split(' ')[0]) < 10 ? "0" + data[selectedIndex].end_month.split(' ')[0] + "/" + monthIndexval : "" + data[selectedIndex].end_month.split(' ')[0] + "/" + monthIndexval
			} else {
				let todaydate = new Date();
				let day: any = todaydate.getDate();
				let month: any = todaydate.getMonth() + 1;
				let year = todaydate.getFullYear();
				if (day < 10) {
					day = "0" + day
				}
				if (month < 10) {
					day = "0" + day
				}
				monthDate = day + "/" + month + "/" + year
			}
			var startmonthIndex = months.indexOf(data[selectedIndex].start_month.split(' ')[1]) + 1
			var startmonthIndexval = startmonthIndex < 10 ? "0" + startmonthIndex : startmonthIndex
			let startmonthDate = parseInt(data[selectedIndex].start_month.split(' ')[0]) < 10 ? "0" + data[selectedIndex].start_month.split(' ')[0] + "/" + startmonthIndexval : "" + data[selectedIndex].start_month.split(' ')[0] + "/" + startmonthIndexval

			fetchColleges(data[selectedIndex].location.state_code)

			updateValue({
				institute: data[selectedIndex].institute,
				description: data[selectedIndex].description,
				degree: { label: data[selectedIndex].degree, value: data[selectedIndex].degree },
				fieldOfStudy: data[selectedIndex].field_of_study,
				currentEducation: data[selectedIndex].end_month === 'till_date' ? EducationFormElements.currentEducation?.values[1] : EducationFormElements.currentEducation.values[0],
				startingFrom: /^[a-zA-Z]*$/.test(data[selectedIndex].start_month) ? dayjs(data[selectedIndex].start_month + "/" + data[selectedIndex].start_year, "DD/MM/YYYY") : dayjs(startmonthDate + "/" + data[selectedIndex].start_year, "DD/MM/YYYY"),
				to: data[selectedIndex].end_month != "till_date" ? /^[a-zA-Z]*$/.test(data[selectedIndex].end_month) ? dayjs(data[selectedIndex].end_month + "/" + data[selectedIndex].end_year, "DD/MM/YYYY") : dayjs(monthDate + "/" + data[selectedIndex].end_year, "DD/MM/YYYY") : "",
				country: { label: data[selectedIndex].location.country, value: data[selectedIndex].location.country_code },
				state: { label: data[selectedIndex].location.state, value: data[selectedIndex].location.state_code },
				city: data[selectedIndex].location.city,
				activities: data[selectedIndex].activities
			});
			fetchCountries(data[selectedIndex].location.country_code);
			//fetchCourses(data[selectedIndex].degree)
		} else {
			fetchCountries();
			//fetchCourses();
		}
	}, []);

	/**
	 * get list of countries
	 * @param country 
	 */
	const fetchCountries = async (country = '') => {
		try {
			dispatch(setLoading(true));
			let response = await getCountries();
			setcountryList(response.data.map(res => ({ label: res.Country, value: res.CountryCode })));
			if (country) {
				fetchStates(country);
			}
			dispatch(setLoading(false));
		} catch (e: any) {
			dispatch(setLoading(false));
		}
	}

	/**
	 * get course types
	 */
	const fetchCourses = async (course = '') => {
		try {
			dispatch(setLoading(true));
			let response = await getCourse();
			setcourseList(response.data.map(res => ({ label: res.CourseDesc, value: res.CourseDesc })));
			if (selectedIndex !== null && selectedIndex >= 0 && data && data.length > 0) {
				response.data.filter(item => item.CourseDesc == data[selectedIndex].degree).map(itmValue => {
					updateValue({ degree: { label: itmValue.CourseDesc, value: itmValue.CourseDesc } })
				})
			}
			dispatch(setLoading(false));
		} catch (e: any) {
			dispatch(setLoading(false));
		}
	}

	/**
	 * get course types
	 */
	const fetchFieldStudy = async (code = '') => {
		try {
			//dispatch(setLoading(true));
			let response = await getFieldStudy(code);
			setfieldstudyList(response.data.map(res => ({ label: res.SubCourseDesc, value: res.SubCourseDesc })));
			//dispatch(setLoading(false));
		} catch (e: any) {
			dispatch(setLoading(false));
		}
	}



	/**
	 * fetch college list
	 */
	const fetchColleges = async (value) => {
		try {
			dispatch(setLoading(true));
			let response = await getColleges(value);
			setcollegeList(response.data?.map(res => ({ label: res.College, value: res.College, key: res.CollegeCode })) || []);
			dispatch(setLoading(false));
		} catch (e: any) {
			setcollegeList([]);
			dispatch(setLoading(false));
		}
	}
	/**
	 * on change values from form items capture values
	 * @param name 
	 * @param value 
	 * @param values 
	 * @param fieldValues 
	 * @returns 
	 */
	function onValueChange(name, value, values, fieldValues = null) {
		console.log(values)
		let resetValue = {};
		if (name === 'country') {
			fetchStates(value.value);
			resetValue = { ...resetValue, state: null }
		} else if (name === 'currentEducation' && value?.value === 'ongoing') {
			resetValue = { to: null };
		} else if (name === 'state') {
			fetchColleges(value.value);
			resetValue = { ...resetValue, college: null }
		}
		// else if(name == ""){
		// 	updateValue({fieldOfStudy:{label:value,value:value}})
		// }
		console.log(values)
		return [{
			...values,
			...resetValue,
			[name]: value,
		}]
	}

	const fetchStates = async (value) => {
		try {
			dispatch(setLoading(true));
			let response = await getStates(value);
			setstateList(response.data.map(res => ({ label: res.State, value: res.StateCode })));
			dispatch(setLoading(false));
		} catch (e: any) {
			dispatch(setLoading(false));
		}
	}

	const checkSubmit = async () => {

		let valuesArray: any = ["institute", "description", "degree", "fieldOfStudy", "currentEducation", "startingFrom", "activities", "country", "state", "city"];
		if (values?.currentEducation?.value === 'completed') {
			valuesArray.push("to");
		}
		if (validateValues(valuesArray)) {
			showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
		} else {

			let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			try {
				dispatch(setLoading(true));
				let instituteCode = collegelist.filter(item => item.value == values.institute)
				let reqObj: any = {
					"institute": values.institute,
					"institute_code": instituteCode && instituteCode[0]?.key || "",
					"degree": values.degree.value || values.degree,
					"field_of_study": values.fieldOfStudy,
					"start_month": values.startingFrom.format("DD/MM"),
					"start_year": parseInt(values.startingFrom.format("YYYY")),
					"end_month": values.currentEducation.value === 'ongoing' ? 'till_date' : values.to.format("DD/MM"),
					"end_year": values.currentEducation.value === 'ongoing' ? 0 : parseInt(values.to.format("YYYY")),
					// "grade": "A",
					"activities": values.activities,
					"description": values.description,
					// "documents": ["a", "b", "c"],
					"location": {
						"country": values.country.label,
						"country_code": values.country.value,
						"state": values.state.label,
						"state_code": values.state.value,
						"city": values.city,
					}
				}
				let response: any;


				if (selectedIndex !== null && selectedIndex >= 0) {

					response = await updateEducation(reqObj, data[selectedIndex].id);
				} else {
					response = await addEducation(reqObj);
				}
				showToaster(toasterTypes.SUCCESS, response.message);
				props.onClose('callAPI');
				dispatch(setLoading(false));
			} catch (e: any) {
				dispatch(setLoading(false));
			}
		}
	}
	return (
		<ModalComponent
			width={window.innerWidth > 700 ? "800px" : "350px"}
			isOpen={true}
			onClose={() => props.onClose()}
			header="Add Education"
			centered={true}
			customClass='profile-modal'
			body={
				<div>
					<Row>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.country}
								value={values.country}
								values={countryList}
								onChange={(...e) => handleChange(EducationFormElements.country.name, ...e)}
								touched={fields.country && fields.country.hasError}
								error={fields.country && fields.country.errorMsg}
							/>
						</Col>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.state}
								value={values.state}
								values={stateList}
								onChange={(...e) => handleChange(EducationFormElements.state.name, ...e)}
								touched={fields.state && fields.state.hasError}
								error={fields.state && fields.state.errorMsg}
							/>
						</Col>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.city}
								value={values.city}
								onChange={(...e) => handleChange(EducationFormElements.city.name, ...e)}
								touched={fields.city && fields.city.hasError}
								error={fields.city && fields.city.errorMsg}
							/>
						</Col>
					</Row>
					<Row>

					</Row>

					<Row>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.institute}
								value={values.institute}
								values={collegelist && collegelist}
								onChange={(...e) => handleChange(EducationFormElements.institute.name, ...e)}
								touched={fields.institute && fields.institute.hasError}
								error={fields.institute && fields.institute.errorMsg}
							/>
						</Col>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.degree}
								value={values.degree}
								onChange={(...e) => handleChange(EducationFormElements.degree.name, ...e)}
								touched={fields.degree && fields.degree.hasError}
								error={fields.degree && fields.degree.errorMsg}
							/>
						</Col>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.fieldOfStudy}
								value={values.fieldOfStudy}
								onChange={(...e) => handleChange(EducationFormElements.fieldOfStudy.name, ...e)}
								touched={fields.fieldOfStudy && fields.fieldOfStudy.hasError}
								error={fields.fieldOfStudy && fields.fieldOfStudy.errorMsg}
							/>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.currentEducation}
								value={values.currentEducation}
								onChange={(...e) => handleChange(EducationFormElements.currentEducation.name, ...e)}
								touched={fields.currentEducation && fields.currentEducation.hasError}
								error={fields.currentEducation && fields.currentEducation.errorMsg}
							/>
						</Col>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.startingFrom}
								value={values.startingFrom}
								placeholder='DD MM YYYY'
								onChange={(...e) => handleChange(EducationFormElements.startingFrom.name, ...e)}
								touched={fields.startingFrom && fields.startingFrom.hasError}
								error={fields.startingFrom && fields.startingFrom.errorMsg}
							/>
						</Col>
						<Col md={4}>
							<FieldItem
								{...EducationFormElements.to}
								value={values.to}
								placeholder='DD MM YYYY'
								onChange={(...e) => handleChange(EducationFormElements.to.name, ...e)}
								touched={fields.to && fields.to.hasError}
								error={fields.to && fields.to.errorMsg}
								isMandatory={values['currentEducation'] && values['currentEducation'].label == "Completed" ? true : false}
							/>
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<FieldItem
								{...EducationFormElements.activities}
								value={values.activities}
								values={activityList}
								onChange={(...e) => handleChange(EducationFormElements.activities.name, ...e)}
								touched={fields.activities && fields.activities.hasError}
								error={fields.activities && fields.activities.errorMsg}
							/>
						</Col>
					</Row>

					<Row>
						<Col md={12}>
							<FieldItem
								{...EducationFormElements.description}
								value={values.description}
								onChange={(...e) => handleChange(EducationFormElements.description.name, ...e)}
								touched={fields.description && fields.description.hasError}
								error={fields.description && fields.description.errorMsg}
							/>
						</Col>
					</Row>
				</div>
			}
			footer={
				<div>
					<CustomButton type="primary" isDisabled={false} text="Save" onClick={() => checkSubmit()}></CustomButton>
				</div>
			}
		/>
	)
}